import React, { ReactNode } from "react";
import { AuthProvider } from "../contexts/AuthContext";

interface LoginLayoutProps {
  children: ReactNode;
}

// The LoginLayout wraps content with AuthProvider but doesn't check authentication
const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return (
    <AuthProvider>
      <main className="flex-grow">{children}</main>
    </AuthProvider>
  );
};

export default LoginLayout;
